import { render, staticRenderFns } from "./OrderedComplete.vue?vue&type=template&id=0324b49e&scoped=true"
import script from "./OrderedComplete.vue?vue&type=script&lang=js"
export * from "./OrderedComplete.vue?vue&type=script&lang=js"
import style0 from "./OrderedComplete.vue?vue&type=style&index=0&id=0324b49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0324b49e",
  null
  
)

export default component.exports